/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { getLatLng, geocodeByAddress } from 'react-places-autocomplete';

import styles from './index.module.scss';
import { mapsKey } from '../../../config';

const circleColor = '#FFD400';

const Map = ({ baseZip, radius }) => {
  const [center, setCenter] = useState();
  const radMeters = radius * 1609;
  const zoom = 10 - Math.floor(radius / 15);

  useEffect(async () => {
    if (baseZip && window.google) {
      geocodeByAddress(baseZip)
        .then((results) => getLatLng(results[0]))
        .then((latLng) => {
          setCenter(latLng);
        }).catch(() => {});
    }
  }, [baseZip]);

  if (!center) {
    return <div className={styles.map} />;
  }

  return (
    <div className={styles.map}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: mapsKey }}
        defaultCenter={center}
        defaultZoom={zoom}
        options={{
          fullscreenControl: false,
          panControl: false,
          mapTypeControl: false,
          scrollwheel: false,
        }}
        onGoogleApiLoaded={({ map }) => new google.maps.Circle({
          strokeColor: circleColor,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: circleColor,
          fillOpacity: 0.3,
          map,
          center,
          radius: radMeters,
        })}
      />
    </div>
  );
};

Map.propTypes = {
  baseZip: PropTypes.string,
  radius: PropTypes.number,
};

export default Map;
